const RUTAS_CAMBIOS_FORMULARIOS = [

  // Empresa
  'companies/detail',
  'companies/config',
  'companies/reportconfig',
  'companies/apsconfig',
  'companies/pdftemplate',

]
 
export { RUTAS_CAMBIOS_FORMULARIOS }
